import Blue from "~/core";

new Blue({
  name: 'LoadMorePager',
  selector: ".loadMorePager",
  setup(loadMorePager) {
    //parent = this;
    //const loadMoreList = loadMorePager.querySelector(".loadMoreList");
    //const loadMoreButton = loadMorePager.querySelector(".loadMoreButton");
    //let listEndPointPath = loadMorePager.getAttribute('data-list');
    //let page = loadMorePager.getAttribute('data-page');
    //let pagesize = loadMorePager.getAttribute('data-pagesize');

    //this.$addEvents(loadMoreButton, "click", () => {
    //  //var xmlhttp = new XMLHttpRequest();
    //  //xmlhttp.onreadystatechange = function () {
    //  //  if (xmlhttp.readyState == XMLHttpRequest.DONE) {   // XMLHttpRequest.DONE == 4
    //  //    if (xmlhttp.status == 200) {

    //  //      loadMoreList.innerHTML += xmlhttp.responseText;
    //  //    }
    //  //    else if (xmlhttp.status == 400) {
    //  //      //alert('There was an error 400');
    //  //    }
    //  //    else {
    //  //      //  alert('something else other than 200 was returned');
    //  //    }
    //  //  }
    //  //};
    //  //var listRequest = parent.listEndPointPath + "?page=" + parent.page + "&pageSize=" + parent.pagesize;
    //  //xmlhttp.open("GET", listRequest, true);
    //  //xmlhttp.send();
     
    //});


  }
});